(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends window.HTMLElement {
    connectedCallback() {
      this.header = this.children[0]
      this.burger = this.querySelector('.burger')
      this.burgerClose = this.querySelector('.burger-close')
      this.thresholdEl = this
      this.currentScrollY = document.documentElement.scrollTop
      this.preventReveal = false
      this.resizeObserver = null
      this.burger.addEventListener('click', this.onBurgerClick.bind(this))
      this.burgerClose.addEventListener(
        'click',
        this.onBurgerCloseClick.bind(this)
      )
      window.addEventListener('scroll', this.onScroll.bind(this), false)
      this.setThreshold()
      this.reset()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler)
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal !== newVal) {
        this[name] = newVal
      }
      this.setThreshold()
    }

    setThreshold() {
      this.thresholdEl = this.header
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
      this.resizeObserver = new window.ResizeObserver(entries => {
        this.thresholdBounds = entries[0].contentRect
        this.header.classList.remove('is-mobile-menu')
      })
      this.resizeObserver.observe(this.thresholdEl)
      this.onScroll()
    }

    hideHeaderOnScrollUp() {
      this.preventReveal = true
    }

    onScroll() {
      const scrollY = window.scrollY
      const threshold =
        this.thresholdBounds || this.thresholdEl.getBoundingClientRect()
      this.pastThreshold(scrollY > threshold.bottom)
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return
      if (scrollY > this.currentScrollY && scrollY > threshold.bottom) {
        if (this.preventHide) return
        window.requestAnimationFrame(this.hide.bind(this))
      } else if (scrollY < this.currentScrollY && scrollY > threshold.bottom) {
        if (!this.preventReveal) {
          window.requestAnimationFrame(this.reveal.bind(this))
        } else {
          window.clearTimeout(this.isScrolling)
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false
          }, 10)
          window.requestAnimationFrame(this.hide.bind(this))
        }
      } else if (scrollY <= threshold.top) {
        window.requestAnimationFrame(this.reset.bind(this))
      }
      this.currentScrollY = scrollY
    }

    onBurgerClick(e) {
      e.preventDefault()
      this.header.classList.add('is-mobile-menu')
    }

    onBurgerCloseClick(e) {
      e.preventDefault()
      this.header.classList.remove('is-mobile-menu')
    }

    pastThreshold(isPast) {
      if (isPast) {
        this.header.classList.add('is-past-thresh')
        this.header.classList.remove('not-past-thresh')
      } else {
        this.header.classList.add('not-past-thresh')
        this.header.classList.remove('is-past-thresh')
      }
    }

    hide() {
      if (document.documentElement.classList.contains('overflow-hidden')) return
      this.header.classList.add('is-hidden')
      this.header.classList.remove('is-revealed')
    }

    reveal() {
      this.header.classList.add('is-revealed')
      this.header.classList.remove('is-hidden')
    }

    reset() {
      this.header.classList.add('is-revealed')
      this.header.classList.remove('is-hidden')
    }
  }

  window.customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();
})();
